export default function generatedReportsDirective() {
  return {
    template: require('./generated-reports.html'),
    controller: 'GeneratedReportsController',
    controllerAs: 'generatedReportsVM',
    bindToController: true,
    replace: true,
  };
}
